import { State } from '../state';

export const products: State = {
    url: 'products',
    oldUrls: ['products/service']
};

export const newProduct: State = {
    url: 'products/new',
    parent: products
};

export const editProduct: State = {
    url: 'products/edit',
    parent: products
};
